import React from "react";
import PageContainer from "../../layouts/PageContainer";
import List from "./List";
import ResolvedList from "./ResolvedList";

const Poster = () => {
  return (
    <React.Fragment>
      <PageContainer pageheading="REPORT USERS">
        <List />
      </PageContainer>
      <PageContainer pageheading="RESOLVED REPORTS">
        <ResolvedList />
      </PageContainer>
    </React.Fragment>
  )
};

export default Poster;